import { message, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { getCookie } from "typescript-cookie";
import { EntEntityTypes } from "../../../../../models/handBooks/entityTypes";
import { useAddEntityTypesMutation, useDeleteEntityTypesMutation, useEditEntityTypesMutation } from "../../../../../redux/api/handBooksApi/entityTypesApi";

const useEntityTypes = (modal: any, refresh?: () => void) => {
    const { t } = useTranslation()
    const { confirm } = modal;
    const [addEntityTypes] = useAddEntityTypesMutation();
    const [deleteEntityTypes] = useDeleteEntityTypesMutation();
    const [editEntityTypes] = useEditEntityTypesMutation();

    async function onAddEntityTypes(newEntityTypes: EntEntityTypes): Promise<boolean> {
        try {
            let status: boolean = false;
            await addEntityTypes(newEntityTypes).then((response: any) => {
                if (response.error) {
                    const isKyrgyz = getCookie('i18next') === 'ky';
                    const lang = isKyrgyz ? 'kg' : 'ru';
                    const res = response.error.data?.res;
                    const errorMessages = Array.isArray(res)
                        ? res.map((error: any) => error[lang] || error.ru).join('\n')
                        : response.error.data?.msg || t('unknownError'); 
                    throw new Error(errorMessages);
                }
                if (response.data.success) {
                    status = true;
                    message.success(t('msg.successAdd'));
                    if (refresh) refresh();
                }
            }).catch((error: any) => {
                modal.error({ title: t('msg.error'), content: String(error.message) });
            });
            return status;
        } catch (error: any) {
            modal.error({ title: t('msg.error'), content: String(error.message) });
            return false;
        }
    }

    async function onDeleteEntityTypes(entityTypes: EntEntityTypes) {
        try {
            let status: boolean = false;
            confirm({
                centered: true,
                title: t('msg.confirmDeleteText'),
                okText: t('general.yes'),
                cancelText: t('general.no'),
                onOk() {
                    deleteEntityTypes(entityTypes.id as number).then((response: any) => {
                        if (response.error !== undefined && response.error.status === 400) {
                            status = false;
                            throw new Error(response.error.data.message);
                        }
                        if (response.data.success) {
                            status = true;
                            Modal.success({ title: t('msg.successDelete') });
                            if (refresh) refresh();
                        }
                    }).catch((error: any) => {
                        Modal.error({ title: t('msg.error'), content: String(error.message) });
                    });
                }
            })
            return status;
        } catch (error: any) {
            Modal.error({ title: t("msg.error"), content: String(error.message) });
            return false;
        }
    };

    async function onEditEntityTypes(editedEntityTypes: EntEntityTypes): Promise<boolean> {
        try {
            let status: boolean = false;
            await editEntityTypes(editedEntityTypes).then((response: any) => {
                if (response.error !== undefined && response.error.status === 400) {
                    throw new Error(response.error.data.message);
                }
                if (response.data.success) {
                    status = true;
                    Modal.success({ title: t('msg.successEdited') });
                    if (refresh) refresh();
                }
            }).catch((error: any) => {
                Modal.error({ title: t('msg.error'), content: String(error.message) });
            });
            return status;
        } catch (error: any) {
            Modal.error({ title: t("msg.error"), content: String(error.message) });
            return false;
        }
    };

    return { onAddEntityTypes, onDeleteEntityTypes, onEditEntityTypes };
}

export { useEntityTypes };
